import { Component, OnInit, Optional, Inject } from '@angular/core';
import { ModPreloginService } from '../../services/modprelogin-service.service';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
    selector: 'mod-marketNews',
    templateUrl: './market-news.component.html',
    styleUrls: ['./market-news.component.css']
})
export class MarketNewsComponent implements OnInit {

    public dataBlock: any[] = new Array();
    private appSettings: any;
    public header: string = '';
    public enablePreLoginModContent: boolean = true;

    constructor(
        private modPreloginService: ModPreloginService,
        private translationService: PershingTranslationService,
        @Optional() @Inject('AppSettings') appSettings: any
    ) {
        this.appSettings = appSettings;
        this.header = 'MARKET_NEWS';
        this.translationService.addTranslationFolder('@pershing/nxi-ng-mod', 'node_modules/@pershing/nxi-ng-mod/lib');
    }

    ngOnInit() {
        if ((!this.appSettings.ibdConfigMap.enablePreLoginModContent) ||
            (this.appSettings.language === 'es' && this.appSettings.ibdConfigMap.disableSpanishPreLoginModContent)) {
            this.enablePreLoginModContent = false;
        }
        this.getModResponse();
    }

    getModResponse() {
        this.modPreloginService.getModPreloginComponentRespose(this.appSettings.ibdConfigMap.modApiUrl, 'welcomemarketnews').subscribe(
            resp => {
                let response: any[] = resp;
                for (let indvBlocks in response) {
                    if (response.hasOwnProperty(indvBlocks)) {
                        this.dataBlock.push(response[indvBlocks]);
                    }
                }
            }
        );
    }
}
